import api from './api';
import type { UsuarioDto, UsuarioCreateRequest } from '@/types/usuario';

export const usuariosApi = {
  findAll: () =>
    api.get<UsuarioDto[]>('/usuarios').then((r) => r.data),

  findById: (id: number) =>
    api.get<UsuarioDto>(`/usuarios/${id}`).then((r) => r.data),

  create: (data: UsuarioCreateRequest) =>
    api.post<UsuarioDto>('/usuarios', data).then((r) => r.data),

  update: (id: number, data: UsuarioCreateRequest) =>
    api.put<UsuarioDto>(`/usuarios/${id}`, data).then((r) => r.data),

  toggleEstado: (id: number) =>
    api.patch(`/usuarios/${id}/estado`),
};
